import { Routes, Route, Navigate } from "react-router-dom"

import { useSession } from "@/lib/useSession"
import { LoginPage } from "@/pages/LoginPage"
import { DashboardPage } from "@/pages/DashboardPage"
import { DeviceDetailPage } from "@/pages/DeviceDetailPage"
import { BuildsPage } from "@/pages/BuildsPage"
import { HelpPage } from "@/pages/HelpPage"
import { AppShell } from "@/components/AppShell"

function RequireAuth({ children }: { children: React.ReactNode }) {
  const user = useSession()
  if (user === undefined) {
    return (
      <div className="flex min-h-svh items-center justify-center text-sm text-muted-foreground">
        טוען…
      </div>
    )
  }
  if (user === null) {
    return <Navigate to="/login" replace />
  }
  return <AppShell user={user}>{children}</AppShell>
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/devices/:id"
        element={
          <RequireAuth>
            <DeviceDetailPage />
          </RequireAuth>
        }
      />
      <Route
        path="/builds"
        element={
          <RequireAuth>
            <BuildsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/help"
        element={
          <RequireAuth>
            <HelpPage />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
